(ns frontend.actions.sales-opportunity-stages
  (:require
   [frontend.conn :as conn]
   [promesa.core :as p]))

(defn *->disable
  [data on-success! on-error!]
  (-> (conn/sendp! :sales-opportunity-stage/disable!
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->reorder!
  [data on-success! on-error!]
  (-> (conn/sendp! :sales-opportunity-stage/reorder data)
      (p/then on-success!)
      (p/catch on-error!)))
